export const ActionStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  PARTIAL_SUCCESS: "PARTIAL_SUCCESS",
};
